module.exports = __webpack_public_path__ + "img/hr-brown-fluff-04.2ef4aafb.png";